// helper function that exports the secret used
// for JWT security
// the extra layer helps with security

export default {
    'secret': 'wslfishyfishybobbityboo'
}